export default {
  title: 'Bestellung anpassen',
  product_info: {
    earn_points: 'Verdienen Sie {{points}} Punkte',
  },
};
